import { useEffect, useRef } from 'react'
import { rfStore } from '../lib/rfstore'

/**
 * Leitura do CW decodificado.
 *
 * Mesmo padrão de RXReadout/SMeter: `setRX` não notifica o React de
 * propósito (é o caminho quente, ~10 Hz), então isto se atualiza por
 * `requestAnimationFrame` escrevendo direto no nó, em vez de depender de
 * re-render.
 *
 * O texto já vem PRONTO do servidor (RXParams.cw_text) — já é a cópia
 * corrompida pelo SNR deste ouvinte especificamente. O componente só mostra
 * o que chegou, não decodifica nada.
 */
export function CWReadout() {
  const ref = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    let raf = 0
    let ultimo: string | null = null

    const tick = () => {
      const s = rfStore.snapshot()
      const texto = rfStore.isReceiving(performance.now()) ? s.rx?.cw_text || '' : ''

      if (texto !== ultimo) {
        el.textContent = texto
        el.classList.toggle('vazio', texto === '')
        ultimo = texto
      }
      raf = requestAnimationFrame(tick)
    }

    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [])

  return <p className="cw-decodificado vazio" ref={ref} />
}
